<template>
  <div class="max-width">
    <v-row class="bg_1 ma-1">
      <v-col class="d-flex" md="1">
        <div class="col-lg-4">
          <a
            class="Button"
            v-if="this.options.page != 1"
            @click="onPaginationChangePrevious"
          >
            Previous</a
          >
        </div>
      </v-col>
      <v-col class="d-flex" md="1">
        <div class="col-lg-4">
          <a class="Button1"> {{ this.options.page }}</a>
        </div>
      </v-col>
      <v-col class="d-flex" md="1">
        <div class="col-lg-4">
          <span
            v-if="options.total > this.options.page"
            class="Button"
            @click="onPaginationChangeNext"
          >
            Next</span
          >
        </div>
      </v-col>
      <v-col class="d-flex">
        <div class="col-lg-4">
          <label class="small">{{
            recordFrom + ' - ' + recordTo + ' of ' + noOfRecords
          }}</label>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from '@/plugins/axios';
import { mapState } from 'vuex';

export default {
  props: {
    // Request URL
    url: {
      type: String,
      default: '',
    },
    filter: {
      type: Object,
      default: {},
    },

    value: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    options: {
      handler(val) {
        this.$emit('paginationOptions', val);
      },
      deep: true,
    },
    filter: {
      handler(val) {
        this.fetchData();
      },
      deep: true,
    },
  },
  data() {
    return {
      hadData: false,
      pageSizes: [5, 10, 15],
      noOfRecords: 0,
      circle: false,
      disabled: false,
      DisabledPagination: false,

      nextIcon: 'mdi-arrow-right',
      nextIcons: ['mdi-chevron-right', 'mdi-arrow-right', 'mdi-menu-right'],
      prevIcon: 'mdi-arrow-left',
      prevIcons: ['mdi-chevron-left', 'mdi-arrow-left', 'mdi-menu-left'],

      selectedPage: 1,
      totalVisiblePages: 10,
      selectedPageSize: 10,

      options: {
        descending: true,
        page: 1,
        perPage: 15,
        rowsPerPage: 5,
        sortBy: 'fat',
        totalItems: 0,
        rowsPerPageItems: [5, 10, 20, 50],
        total: 0,
      },
    };
  },
  computed: {
    ...mapState('orders', ['FilterDate']),
    recordFrom: {
      get() {
        var from =
          this.noOfRecords < this.options.perPage
            ? this.noOfRecords
            : this.options.perPage * this.options.page - this.options.perPage;
        if (this.noOfRecords > 0 && from == 0) {
          return 1;
        } else {
          return from;
        }
      },
      set() {},
    },
    recordTo: {
      get() {
        var to =
          this.noOfRecords < this.options.perPage
            ? this.noOfRecords
            : this.options.perPage * this.options.page;
        if (to > this.noOfRecords) {
          return this.noOfRecords;
        }
        return to;
      },
      set() {},
    },
    rowsPerPageItems: {
      get() {
        var rowsPerPage = this.options.rowsPerPageItems
          ? this.options.rowsPerPageItems
          : [15, 20, 25, 30];

        if (this.noOfRecords < 5) {
          rowsPerPage = [1];
          this.options.perPage = 1;
        }
        // console.log(
        //   rowsPerPage,
        //   "-------iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiippppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppp"
        // );
        // var final = rowsPerPage.filter((item) => item <= this.noOfRecords);
        return 15;
      },
      set() {},
    },
  },
  created() {
    // Fetch data
    this.fetchData();
  },
  mounted: function () {
    this.SetPaginationSettings();
  },
  methods: {
    refreshData() {
      this.fetchData();
    },

    fetchData() {
      if (!this.DisabledPagination) {
        this.options.page = 1;
        axios
          .get(this.url, {
            params: {
              page: this.options.page,
              size: this.options.perPage,
            },
          })
          .then((res) => {
            this.DisabledPagination = false;

            if (res.data.meta) {
              this.noOfRecords = res.data.meta.totalItems;
              this.options.total = res.data.meta.lastPage;

              if (res.data.data.length != 0) this.hadData = true;
              else this.hadData = false;
              this.$emit('response', res.data.data);
            } else {
              this.noOfRecords = res.data.length;
              this.options.total = 1;
              this.$emit('response', []);
            }
          })
          .catch((err) => {
            this.$emit('response', []);
          });
      } else {
        axios
          .get(this.url, {
            params: {
              page: this.options.page,
              size: this.options.perPage,
            },
          })
          .then((res) => {
            this.DisabledPagination = false;

            if (res.data.meta) {
              this.noOfRecords = res.data.meta.totalItems;
              this.options.total = res.data.meta.lastPage;

              if (res.data.data.length != 0) this.hadData = true;
              else this.hadData = false;
              this.$emit('response', res.data.data);
            } else {
              this.noOfRecords = res.data.length;
              this.options.total = 1;
              this.$emit('response', []);
            }
          })
          .catch((err) => {
            this.$emit('response', []);
          });
      }
    },
    onPaginationChangeNext() {
      this.DisabledPagination = true;
      this.options.page = this.options.page + 1;
      this.fetchData();
      // this.changeSelectedPageRange();
    },
    onPaginationChangePrevious() {
      this.DisabledPagination = true;

      this.options.page = this.options.page - 1;
      this.fetchData();
      // this.changeSelectedPageRange();
    },
    onChangePageSize() {
      this.options.page = 1;
      this.selectedPage = 1;
      // this.changeSelectedPageRange();
      this.fetchData();
    },
    changeSelectedPageRange() {
      this.options.length = this.noOfRecords / this.selectedPageSize;
      this.recordFrom = this.selectedPageSize * (this.selectedPage - 1) + 1;
      this.recordTo =
        this.noOfRecords < 5
          ? this.noOfRecords
          : this.selectedPageSize * this.selectedPage;
    },

    SetPaginationSettings() {
      this.pageSizes = JSON.parse(15);
      this.options.rowsPerPageItems = JSON.parse(15);

      this.totalVisiblePages = 5;
      this.options.perPage = 15;
    },
  },
};
</script>

<style scoped>
.Button {
  border: none;
  background: #589442;
  outline: none;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  padding: 6px 15px;
  color: #fff;
  font-weight: 500;
  text-align: center;
  font-size: 16px;
  font-size: 0.775rem;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  border-radius: 3px;
  line-height: normal;
}

.Button1 {
  border: none;
  outline: none;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  padding: 6px 15px;
  color: rgb(19, 17, 17);
  font-weight: 500;
  text-align: center;
  font-size: 16px;
  font-size: 0.775rem;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  border-radius: 3px;
  line-height: normal;
}
.Footer1 {
  margin-top: 18px;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}
</style>
